export default "__VITE_ASSET__ef3017cc__"